export default __webpack_public_path__ + "static/media/smartsuite.08ae6bd8.svg";